import { graphql } from "gql.tada";

export const GetRootNavigationItem = graphql(
  `
    query GetRootNavigationItem(
      $locale: String
      $preview: Boolean
      $allowedChildren: Int = 10
    ) {
      navigationItemCollection(
        locale: $locale
        preview: $preview
        where: { title: "Root Navigation" }
        limit: 1
      ) {
        items {
          __typename
          title
          childrenCollection(limit: $allowedChildren) {
            items {
              __typename
              ... on Page {
                slug
                title
                navigationImage {
                  url
                  title
                }
                navigationAlternateLabel
                navigationAccessibilityLabel
              }
              ... on NavigationItem {
                title
                childrenCollection(limit: $allowedChildren) {
                  items {
                    __typename
                    ... on Page {
                      slug
                      title
                      navigationImage {
                        url
                        title
                      }
                      navigationAlternateLabel
                    }
                    ... on NavigationItem {
                      title
                    }
                  }
                }
              }
            }
          }
          menuAccessibilityLabel
        }
      }
    }
  `
);
